import React, { PropsWithChildren } from 'react';

import { P } from './elements';

export const Description: React.FC<PropsWithChildren> = ({ children }) => {
  if (children === null) {
    return null;
  }
  return <P>{children}</P>;
};
